import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

function initArticlesScroll(scrollContainer) {
	const articlesSroll = new LocomotiveScroll({
		el: scrollContainer,
		smooth: true,
		gestureDirection: 'both',
		tablet: {
			smooth: false,
		},
		mobile: {
			smooth: false,
		},
	});

	window.articlesSroll = articlesSroll;

	articlesSroll.on('scroll', ({ limit, scroll }) => {
		const progress = scroll.y / limit.y;
		
		if (scroll.y > 0) {
			document.body.classList.add('fixed-locomotive');
		} else {
			document.body.classList.remove('fixed-locomotive');
		}

		ScrollTrigger.update();

		  if (progress > 0.3) {
			document.body.dispatchEvent(
			  new CustomEvent("progress-25", { detail: this })
			);
		  }
		  if (progress > 0.5) {
			document.body.dispatchEvent(
			  new CustomEvent("progress-50", { detail: this })
			);
		  }
		  if (progress > 0.75) {
			document.body.dispatchEvent(
			  new CustomEvent("progress-75", { detail: this })
			);
		  }
		  if (progress > 0.95) {
			document.body.dispatchEvent(
			  new CustomEvent("progress-100", { detail: this })
			);
		  }
	});

	document.addEventListener('updateScrollerProxy', () => {
		//console.log('updateScrollerProxy');
		setProxy();
	});

	function setProxy() {
		ScrollTrigger.config({});

		ScrollTrigger.defaults({
			scroller: scrollContainer,
		});
	}

	ScrollTrigger.scrollerProxy(scrollContainer, {
		scrollTop(value) {
			return arguments.length ? articlesSroll.scrollTo(value, 0, 0) : articlesSroll.scroll.instance.scroll.y;
		},
		getBoundingClientRect() {
			return {
				top: 0,
				left: 0,
				width: window.innerWidth,
				height: window.innerHeight,
			};
		},

		pinType: scrollContainer.style.transform ? 'transform' : 'fixed',
	});

	ScrollTrigger.refresh();

	new ResizeObserver(() => {
		if (articlesSroll) articlesSroll.update();
		ScrollTrigger.update();
		ScrollTrigger.refresh();
	}).observe(scrollContainer);
}

export default () => {
	const scrollContainer = document.querySelector('[data-scroll-container]');
	if (scrollContainer && !isTouchDevice) initArticlesScroll(scrollContainer);
};
